import type { TransferScope } from './TransferScopeSelector'

export const getDefaultTransferScope = ({
  isPrimaryAvailable,
  isAssociatedAvailable,
}: {
  isPrimaryAvailable: boolean
  isAssociatedAvailable: boolean
}): TransferScope => {
  if (!isPrimaryAvailable) {
    return 'associated'
  }
  if (!isAssociatedAvailable) {
    return 'primary'
  }

  return 'both'
}
